import { change } from "../sections/insights/util";
import { Icon } from "./icons";

const VS_PREV = "Change vs the previous period of the same length";
const MEANING = {
  good: "Green: the direction you want.",
  bad: "Red: the costly direction.",
  flat: "Grey: volume, neither good nor bad.",
};

/** Period-over-period change. Rates going up are bad by default (unit cost,
 * failures); ``upIsGood`` flips that (savings, cache hits) and ``neutral``
 * drops the colour for volume, spend included. No change is a muted dash. */
export function Delta({
  now,
  prev,
  upIsGood = false,
  points = false,
  neutral = false,
}: {
  now: number;
  prev: number | null;
  upIsGood?: boolean;
  points?: boolean;
  neutral?: boolean;
}) {
  if (prev == null) return null;
  const d = points ? now - prev : change(now, prev);
  if (d == null) return null;
  const shown = points ? Math.round(d * 100) : Math.round(d * 1000) / 10;
  const unit = points ? (Math.abs(shown) === 1 ? " pt" : " pts") : "%";
  if (shown === 0)
    return (
      <span className="ds-delta flat" title={VS_PREV}>
        No change
      </span>
    );
  const up = shown > 0;
  const tone = neutral ? "flat" : up === upIsGood ? "good" : "bad";
  return (
    <span className={`ds-delta ${tone}`} title={`${VS_PREV}. ${MEANING[tone]}`}>
      <Icon name={up ? "trend-up" : "trend-down"} size={12} />
      {up ? "+" : "−"}
      {Math.abs(shown)}
      {unit}
    </span>
  );
}
